'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgCamera(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M1.703 10.715h8.594c1.124 0 1.703-.572 1.703-1.684V3.754c0-1.112-.579-1.684-1.703-1.684H9.249c-.386 0-.52-.084-.758-.328l-.392-.418C7.84 1.054 7.565.9 7.044.9H4.95c-.52 0-.797.154-1.054.424l-.392.418c-.231.244-.366.328-.759.328h-1.04C.583 2.07 0 2.642 0 3.754V9.03c0 1.112.585 1.684 1.703 1.684zm4.294-1.73a2.743 2.743 0 01-2.751-2.757 2.743 2.743 0 012.75-2.757 2.745 2.745 0 012.758 2.757 2.745 2.745 0 01-2.757 2.758zm3.69-3.9a.684.684 0 110-1.369.684.684 0 110 1.368zm-3.69 2.879a1.74 1.74 0 10.005-3.476 1.74 1.74 0 00-.005 3.476z", id: "Camera__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Camera__svg__a" })))));
}

module.exports = SvgCamera;
//# sourceMappingURL=Camera.js.map
